import React from "react";
import LogoOftRegister from "../../assets/logooferta.svg";
import PaginationListTable from "../../Components/PaginationListTable/PaginationListTable"

const OfertaContextualRegistros = () => {
  React.useEffect(() => {
  }, []);

  return (
    <PaginationListTable
    collection="oferta-contextual-log"
    orderby="data"
    orderbyOrientation="desc"
    logo={LogoOftRegister}
    tableTitle="Registros Oferta Contextual"
    searchKeyword="Procure por Usuário"
    tableHeaders={{
      "Ação":"acao",
      "Conteúdo":"conteudo",
      "Data":"data",
      "E-mail":"email",
      "Espaço Comercial":"espacoComercial",     
      "Produto":"produto",
      "Status":"status",
      "Título":"titulo"
    }}
  />
  );
};

export default OfertaContextualRegistros;
